// window.addEventListener('DOMContentLoaded', () => {
//   const accSingleTriggers = document.querySelectorAll('.js-acc-single-trigger');

//   accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));

//   function toggleAccordion() {
//     const item = this.closest('.js-acc-item');
//     const content = item.querySelector('.accordion-single-content');

//     if (item.classList.contains('is-open')) {
//       // Zamykanie
//       content.style.maxHeight = null;
//       item.classList.remove('is-open');
//     } else {
//       // Otwieranie
//       content.style.maxHeight = content.scrollHeight + 'px';
//       item.classList.add('is-open');
//     }
//   }

//   // Inicjalizacja otwartych elementów (jeśli są)
//   document.querySelectorAll('.js-acc-item.is-open').forEach(item => {
//     const content = item.querySelector('.accordion-single-content');
//     content.style.maxHeight = content.scrollHeight + 'px';
//   });
// });

(function () {
  let initialized = false;
  function initAccordion() {
    if (initialized) return;
    const accSingleTriggers = document.querySelectorAll('.js-acc-single-trigger');
    if (!accSingleTriggers.length) return; // jeszcze nie ma elementów

    accSingleTriggers.forEach(trigger => trigger.removeEventListener('click', toggleAccordion));
    accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));

    // Ustaw maxHeight dla już otwartych
    document.querySelectorAll('.js-acc-item.is-open').forEach(item => {
      const content = item.querySelector('.accordion-single-content');
      if (content) content.style.maxHeight = content.scrollHeight + 'px';
    });

    initialized = true;
  }

  function toggleAccordion() {
    const item = this.closest('.js-acc-item');
    if (!item) return;
    const content = item.querySelector('.accordion-single-content');
    if (!content) return;

    if (item.classList.contains('is-open')) {
      content.style.maxHeight = null;
      item.classList.remove('is-open');
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      item.classList.add('is-open');
    }
  }

  // 1) standardowy start po DOMContentLoaded
  document.addEventListener('DOMContentLoaded', initAccordion);

  // 2) jeśli Cookiebot emituje zdarzenie akceptacji -> zainicjalizuj ponownie
  // Obsługujemy popularne nazwy zdarzeń Cookiebot (fallback jeśli różne instalacje)
  try {
    window.addEventListener && window.addEventListener('CookiebotOnAccept', initAccordion);
    window.addEventListener && window.addEventListener('CookiebotOnDecline', initAccordion);
    window.addEventListener && window.addEventListener('CookieConsentDeclaration', initAccordion);
  } catch (e) {
    /* noop */
  }

  // 3) fallback: krótkie okresowe próby inicjalizacji (np. jeżeli Cookiebot blokuje skrypty dopóki nie zaakceptowano)
  const retryInterval = setInterval(() => {
    if (initialized) {
      clearInterval(retryInterval);
      return;
    }
    initAccordion();
  }, 500);

  // 4) opcjonalnie obserwuj DOM, jeśli akordeon ładowany dynamicznie
  const mo = new MutationObserver(() => {
    if (!initialized) initAccordion();
  });
  mo.observe(document.documentElement || document.body, { childList: true, subtree: true });

  // opcjonalne funkcje do zatrzymania obserwatora/intervalu kiedy zainicjalizowano
  const stopIfReady = () => {
    if (initialized) {
      mo.disconnect();
      clearInterval(retryInterval);
    }
  };
  // sprawdzaj co 300ms, aż zatrzymamy
  const stopChecker = setInterval(() => {
    stopIfReady();
    if (initialized) clearInterval(stopChecker);
  }, 300);
})();

